export const connect = (DialogClass, Element) =>
	class extends Element {
		constructor() {
			super();
			this.dialog = null;

			this.addEventListener("click", () => {
				if (!this.hasAttribute("disable-click-handler")) {
					this.showDialog();
				}
			});
		}

		getDialogParams() {
			return [];
		}

		showDialog(zIndex = null) {
			this.classList.add("active");
			if (this.dialog === null) {
				this.dialog = new DialogClass(this);
				this.dialog.node.addEventListener("change", event =>
					this.onDialogChanged(event),
				);
				this.dialog.node.addEventListener("confirm", event => {
					this.onDialogConfirm(event);
				});
				this.dialog.node.addEventListener("close", () => {
					this.classList.remove("active");
					const closeHandler = () => {
						this.dispatchEvent(new CustomEvent("DialogClosed"));
						this.removeEventListener("transitionend", closeHandler);
					};
					this.addEventListener("transitionend", closeHandler);
				});
			}
			this.dialog.show(...this.getDialogParams(), zIndex);
		}

		hideDialog() {
			if (this.dialog !== null) {
				this.dialog.hide();
			}
		}

		onDialogChanged() {}
		onDialogConfirm() {}
	};
